import React, { createContext, useContext, useState } from 'react';

const AccountContext = createContext();

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within AccountProvider');
  }
  return context;
};

export const AccountProvider = ({ children }) => {
  const [accountType, setAccountType] = useState('personal'); // 'personal' or 'business'

  const toggleAccountType = () => {
    setAccountType(prev => prev === 'personal' ? 'business' : 'personal');
  };

  const theme = {
    personal: {
      primary: 'from-red-500 to-red-600',
      primaryHover: 'from-red-600 to-red-700',
      accent: 'red',
      bg: 'bg-red-500',
      text: 'text-red-600',
      border: 'border-red-600',
      activeBg: 'bg-red-50'
    },
    business: {
      primary: 'from-red-700 to-red-800',
      primaryHover: 'from-red-800 to-red-900',
      accent: 'red',
      bg: 'bg-red-700',
      text: 'text-red-700',
      border: 'border-red-700',
      activeBg: 'bg-red-50'
    }
  };

  return (
    <AccountContext.Provider value={{ accountType, toggleAccountType, theme: theme[accountType] }}>
      {children}
    </AccountContext.Provider>
  );
};
